<template>
    <div id="ig-contact-list-page">
        <h3 class="title" v-if="showTitle">{{ $t("wp.contactList") }}</h3>
        <div v-if="checkboxOption.selectedRowKeys.length" class="selection-bar">
            <section class="uncheck" @click="unselectAll">
                <span class="material-icons"> arrow_back </span>
                {{ $t("chatbotv2.uncheckAll") }}
            </section>
            <section class="select" @click="selectAll">{{ $t("chatbotv2.selectAll") }}</section>
            <section class="select" @click="deleteAll">{{ $t("search.integration.deleteAll")}}</section>
            <section class="queries">
                +{{ `${checkboxOption.selectedRowKeys.length} ${$t("wp.contactSelected")}` }}
            </section>
            <section class="actions">
                <a-button class="d-none" ghost disabled>{{ $t("wp.sendBroadcastMessage") }}</a-button>
            </section>
        </div>
        <div class="toolbox">
            <div>
                <slot name="left-actions"></slot>
            </div>
            <div>
                <slot name="middle-actions"></slot>
            </div>
            <div class="buttons">
                <a-dropdown v-if="channel && channel.isDeleted">
                    <SupsisButton xxsmall icon>
                        <i class="material-icons text-warning">more_horiz</i>
                    </SupsisButton>
                    <a-menu slot="overlay">
                        <a-menu-item key="transfer" @click="showTransferModal()">
                            <span>Kişileri Başka Kanala Transfer Et</span>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </div>
        </div>
        <div class="table-wrapper">
            <div class="table-pagination">
                <a-input-search
                    style="width: 300px"
                    v-model="searchText"
                    :placeholder="$t('message.search')"
                    class="row search-input"
                    @input="onSearch($event.target.value)"
                />
                <ve-pagination
                    :total="pagination.total"
                    :page-index="pagination.current"
                    :page-size="pagination.defaultPageSize"
                    :page-size-option="pagination.pageSizeOptions"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
            <ve-table
                :columns="cols"
                :table-data="allContacts"
                :row-style-option="rowStyleOption"
                :border-x="true"
                :border-y="true"
                row-key-field-name="_id"
                id="visitor-table"
                :fixed-header="true"
                :checkbox-option="checkboxOption"
                :clipboard-option="clipboardOption"
            />
            <NoMessage title="Forbidden Channel" desc="You are not allowed to see this channel" v-if="forbidden" />
        </div>
        <Modal2
            title="Transfer Contacts"
            :show-footer="false"
            v-if="transferModalVisible"
            @cancel="transferModalVisible = false"
            class-name="transfer-contact-modal"
        >
            <TransferContacts
                :channel-id="channelId"
                :target-channel-id.sync="targetChannelId"
                :filter-types="['instagram','instagram-v2']"
                @transfer="handleTransfer"
                @cancel="transferModalVisible = false"
            />
        </Modal2>
    </div>
</template>
<script>
import SYSTEM_PUBSUB from "../../../../utils/systemPubSub";
import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import { filter, first, timeout } from "rxjs/operators";
import _ from "lodash";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Vue from "vue";
import VueTheMask from "vue-the-mask";
import VueCountryCode from "vue-country-code";
import log2 from "../../../../utils/log2";
import Modal2 from "../../../../components/common/Modal2.vue";
import { VeLocale, VePagination } from "vue-easytable";
import enUS from "vue-easytable/libs/locale/lang/en-US.js";
import moment from "moment";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import NoMessage from "../../TeamChat/NoMessage.vue";
import InstagramIcon from "../../../../components/svg/InstagramIcon.vue";
import ChatWatcher from "../../../../ChatWatcherV2";
import AiVoiceAgentCallStarter from "../../../../components/AiVoiceAgentCallStarter.vue";
import TransferContacts from "../../IntegrationChannelsItem/TransferContacts.vue";

Vue.use(VePagination);
VeLocale.use(enUS);
Vue.use(VueTheMask);
Vue.use(VueCountryCode);
const log = log2("InstagramContactList");
export default {
    name: "InstagramContactList",
    components: {
        NoMessage,
        Modal2,
        SupsisButton,
        InstagramIcon,
        AiVoiceAgentCallStarter,
        TransferContacts,
    },

    props: {
        allowImport: {
            type: Boolean,
            default: true,
        },
        channel: {
            type: Object,
            required: true,
        },
        channelId: {
            type: String,
            required: true,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        forbidden: {
            type: Boolean,
            default: false,
        },
        allChannelMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            importMode: false,
            transferModalVisible: false,
            targetChannelId: null,
            rowStyleOption: {
                stripe: true,
            },
            clipboardOption: {
                copy: true,
                paste: false,
                cut: false,
                delete: false,
            },
            services: null,
            visible: false,
            confirmLoading: false,
            showAlertMessage: false,
            internationalCallingCode: "90",
            wpContactNumber: "",
            createCustomerGroupFormVisible: false,
            lastPersonelContacts: [],
            searchText: "",
            currentSort: {
                columnKey: "connectionTime",
                order: "ascend",
            },
            pagination: {
                total: 0,
                current: 1,
                defaultPageSize: 50,
                hideOnSinglePage: true,
                pageSizeOptions: [10, 15, 20, 50, 100],
                showQuickJumper: true,
                showSizeChanger: true,
            },
            cols: [
                {
                    field: "",
                    key: "a",
                    type: "checkbox",
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "address",
                    key: "profilePicThumbObj",
                    title: this.$t("message.profile"),
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            "a-avatar",
                            {
                                props: {
                                    size: 30,
                                    src: row.instagramInfo?.profile_pic,
                                    username: row.name,
                                    shape: "square",
                                },
                                style: "background-color: #3899ff; border-radius: 7px !important",
                            },
                            row.name.substr(0, 1).toLocaleUpperCase()
                        );
                    },
                },
                {
                    key: "name",
                    field: "name",
                    title: this.$t("message.name"),
                    width: "",
                    align: "left",
                },
                {
                    key: "phoneNumber",
                    field: `phoneNumber`,
                    title: this.$t("message.number"),
                },
                {
                    key: "email",
                    field: `email`,
                    title: this.$t("message.email"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.email || "-"}</span>;
                    },
                },
                {
                    key: "channelName",
                    field: `channelName`,
                    title: this.$t("message.channel"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.channel?.name || "-"}</span>;
                    },
                },
                {
                    key: "createdAt",
                    field: `createdAt`,
                    title: this.$t("message.createdAt"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{moment(row.createdAt).format("DD.MM.YYYY HH:mm")}</span>;
                    },
                },
                {
                    title: this.$t("message.action"),
                    key: "operation",
                    width: "140px",
                    align: "center",
                    operationColumn: true,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div class="actions">
                                <SupsisButton onClick={() => this.startChat(row)} small>
                                    <i class="material-icons text-primary">quickreply</i>
                                </SupsisButton>
                                <AiVoiceAgentCallStarter
                                    contact={row}
                                    defaultToNumber={row.phone}
                                    hideButton={false}
                                />
                                <SupsisButton onClick={() => this.deleteVisitorConfirm(row)} small>
                                    <i class="material-icons text-danger">delete</i>
                                </SupsisButton>
                                <SupsisButton onClick={() => this.viewContactProfile(row)} small>
                                    <i class="material-icons text-primary">contact_page</i>
                                </SupsisButton>
                            </div>
                        );
                    },
                },
            ],
            loading: true,
            loadingInstance: null,
            allContacts: [],
            checkboxOption: {
                selectedRowKeys: [],
                // row select change event
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    console.log("selectedRowChange", { row, isSelected, selectedRowKeys });
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
                // selected all change event
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    console.log("selectedAllChange", { isSelected, selectedRowKeys });
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
            },
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            siteId: (state) => state.site.site._id,
            user: (state) => state.auth.user,
            instagramChannels: (state) => state.channel.channels.filter((x) => ["instagram","instagram-v2"].includes(x.type)),
        }),

        ...mapGetters({
            myActiveConversations: "chat/getMyActiveConversations",
        }),
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            getContactListByChannel: "chat/getContactListByChannel",
            getContactListByChannels: "chat/getContactListByChannels",
            deleteVisitor: "visitor/deleteVisitor",
            deleteMultiVisitor: "visitor/deleteMultiVisitor",
            addNewWindow: "app/addNewWindow",
            moveContactsToOtherChannel: "visitor/moveContactsToOtherChannel",
        }),
        ...mapMutations({}),
        pageNumberChange(pageIndex) {
            this.pagination.current = pageIndex;
            this.fetchContacts();
        },
        pageSizeChange(pageSize) {
            this.pagination.pageSize = pageSize;
            this.fetchContacts();
        },

        selectAll() {
            this.checkboxOption.selectedRowKeys = this.allContacts.map((x) => x._id);
        },
        deleteAll() {
            this.$confirm({
                title: "Seçili Kişileri sil",
                content: "Seçili Kişileri silmek istediğinizden emin misiniz?",
                okText: "Sil",
                okType: "danger",
                cancelText: "Kapat",
                onOk: () => {
                    this.deleteMultiVisitor(this.checkboxOption.selectedRowKeys).then((isSuccess) => {
                        if (isSuccess) {
                            this.$message.success(`${this.checkboxOption.selectedRowKeys.length} kişi silindi`);
                            this.allContacts = this.allContacts.filter(
                                (x) => !this.checkboxOption.selectedRowKeys.includes(x._id)
                            );
                            this.checkboxOption.selectedRowKeys = [];
                            this.refresh();
                        }
                    });
                },
            });
        },
        unselectAll() {
            this.checkboxOption.selectedRowKeys = [];
        },
        deleteVisitorConfirm(item) {
            this.$confirm({
                title: "Kişiyi sil",
                content: "Kişiyi slimek istediğinizden emin misiniz?",
                okText: "Sil",
                okType: "danger",
                cancelText: "Kapat",
                onOk: () => {
                    this.deleteVisitor(item._id).then((res) => {
                        this.$message.success("Kişi silindi");
                        this.allContacts = this.allContacts.filter((x) => x._id !== item._id);
                    });
                },
            });
        },
        viewContactProfile(item) {
            this.addNewWindow({
                type: "show-visitor",
                // title: `${item.name} / ${item.phoneNumber} Profile`,
                title: this.$t("message.instagramUserProfile") + "/" + `${item.name}`,
                payload: {
                    visitorId: item._id,
                },
                footer: false,
                sliderOptions: {
                    nextAvailable: !!this.allContacts[this.allContacts.indexOf(item) + 1],
                    prevAvailable: !!this.allContacts[this.allContacts.indexOf(item) - 1],
                    next: () => {
                        log("next called");
                        const index = this.allContacts.findIndex((x) => x._id === item._id);
                        this.viewContactProfile(this.allContacts[index + 1]);
                    },
                    prev: () => {
                        log("prev called");
                        const index = this.allContacts.findIndex((x) => x._id === item._id);
                        this.viewContactProfile(this.allContacts[index - 1]);
                    },
                },
            });
        },
        startChat(row) {
            ChatWatcher.startChatImmediately({
                instagramUserId: row.instagramUserId,
                channelId: row.channel._id,
                channelType: row.channel.type,
            });
        },
        showTransferModal() {
            this.transferModalVisible = true;
        },
        
        handleTransfer() {
            if (!this.targetChannelId) {
                this.$message.error("Lütfen bir hedef kanal seçin");
                return;
            }
            
            this.$confirm({
                title: "Kişileri Transfer Et",
                content: "Tüm kişileri seçilen kanala taşımak istediğinizden emin misiniz?",
                okText: "Transfer Et",
                okType: "primary",
                cancelText: "İptal",
                onOk: () => {
                    this.transferContacts();
                },
            });
        },
        
        async transferContacts() {
            try {
                const response = await this.moveContactsToOtherChannel({
                    sourceChannelId: this.channelId,
                    targetChannelId: this.targetChannelId,
                });
                console.log("transferContacts => response", response);
                
                if (response.success) {
                    this.$message.success("Kişiler başarıyla transfer edildi");
                    this.transferModalVisible = false;
                    this.targetChannelId = null;
                    this.fetchContacts();
                } else {
                    this.$message.error("Transfer işlemi başarısız oldu");
                }
            } catch (error) {
                this.$message.error(
                    "Transfer işlemi sırasında bir hata oluştu: " + (error.message || "Bilinmeyen hata")
                );
            }
        },
        refresh: _.debounce(function () {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 500);
            this.pagination.current = 1;
            this.fetchContacts();
        }, 400),

        async handleTableChange(pagination, filters, sorter) {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 370);
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            await this.fetchContacts();
        },
        onSearch(value) {
            log("onSearch", value);
            this.searchText = value;
            this.refresh();
        },
        async fetchContacts() {
            if (!this.channel && !this.allChannelMode) return;
            if (this.forbidden && !this.allChannelMode) {
                this.loading = false;
                this.allContacts = [];
                this.pagination.total = 0;
                this.searchText = "";
                return;
            }
            this.loading = true;
            const allContacts = this.allChannelMode
                ? await this.getContactListByChannels({
                      channelIds: this.instagramChannels.map((x) => x._id),
                      pageCount: this.pagination.current,
                      perPage: this.pagination.pageSize || this.pagination.defaultPageSize || 10,
                      searchValue: this.searchText,
                      platform: "instagram",
                  })
                : await this.getContactListByChannel({
                      channel: this.channel._id,
                      pageCount: this.pagination.current,
                      perPage: this.pagination.pageSize || this.pagination.defaultPageSize || 10,
                      searchValue: this.searchText,
                  });

            console.log("allContacts request:", allContacts);

            this.allContacts = allContacts.result.map((x) => {
                x.channelName = !!x.channel ? x.channel.name : "-";
                x.name = !!x.fullname ? x.fullname : "-";
                x.phoneNumber = !!x.whatsappNumber ? x.whatsappNumber : "-";
                return x;
            });
            this.pagination.total = allContacts.totalResult;
            this.loading = false;
        },
    },
    async mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector(".table-wrapper"),
            name: "wave",
        });
        this.loading = !!this.channel && !this.forbidden;
        if (this.loading) this.loadingInstance.show();
        await this.fetchContacts();
    },
    watch: {
        loading(val) {
            if (val) {
                this.loadingInstance.show();
            } else {
                this.loadingInstance.close();
            }
        },
        channelId(val) {
            this.searchText = "";
            this.pagination.current = 1;
            this.fetchContacts();
        },
        allChannelMode(val) {
            this.searchText = "";
            this.pagination.current = 1;
            this.fetchContacts();
        },
    },
};
</script>

<style lang="scss">
#visitor-table {
    .ve-table-body-td {
        padding: 0 2px !important;
    }

    .actions {
        display: flex;
        gap: 5px;

        .supsis-button {
            background: none;
            border: none;
            padding: 3px;

            &.instagram {
                width: 25px;
                height: 25px;
            }

            svg {
                width: 20px;
                height: 20px;
            }
        }

        /* AI Voice Agent Button Styling */
        .ai-voice-agent-call-starter {
            display: inline-flex;

            .conversation-actions-button {
                padding: 4px;
                background: none;
                border: none;
                cursor: pointer;

                .material-icons {
                    font-size: 20px;
                }
            }
        }
    }
}
</style>
<style scoped lang="scss">
#ig-contact-list-page {
    margin: 30px;

    .table-pagination {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
    }

    .toolbox {
        display: flex;
        justify-content: space-between;

        .buttons {
            display: flex;
            gap: 10px;
        }
    }

    .delete-chat {
        background: none;
        border: none;
        margin-right: 5px;

        &:hover {
            background-color: #c0bfbf;
            border-radius: 10px;
        }
    }

    .ant-modal-body {
        padding: 24px;
        font-size: 14px;
        line-height: 1.5;
        word-wrap: break-word;
        display: flex !important;
        flex-direction: row !important;
        height: 80px !important;
    }

    .ant-table-row {
        border-bottom: 1px solid lightgrey;
    }

    .ant-table table {
        border-collapse: collapse !important;
    }

    .ant-table-small {
        border: none !important;
    }

    .ant-table-body > table > .ant-table-tbody > tr > td {
        border: none !important;
    }

    .ant-table-body > table {
        border-right: none !important;
        border-left: none !important;
        line-height: 10px !important;
    }

    .ant-table-body > table > .ant-table-thead > tr > th {
        border: none !important;
    }

    .ant-table-small {
        .ant-table-tbody {
            td {
                padding: 2px 2px !important;
                height: 10px !important;
            }

            .ant-table-row {
                height: 10px !important;
            }
        }
    }

    .selection-bar {
        align-items: center;
        background: #006cff;
        color: #fff;
        display: flex;
        flex-wrap: wrap;
        height: 50px;
        left: 0;
        padding: 10px 30px;
        position: static;
        right: 0;

        section.uncheck {
            align-items: center;
            cursor: pointer;
            display: flex;
            grid-area: uncheck;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }

            .material-icons {
                font-size: 15px;
                margin-right: 10px;
                margin-top: 2px;
            }
        }

        section.select {
            cursor: pointer;
            grid-area: select;
            margin-left: 20px;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }
        }

        section.queries {
            grid-area: queries;
            margin-left: auto;
        }

        section.actions {
            align-items: center;
            display: flex;
            grid-area: actions;
            justify-content: center;
            margin-left: 20px;
            gap: 5px;

            div {
                align-items: center;
                border: 1px solid #fff;
                border-radius: 100%;
                cursor: pointer;
                display: flex;
                height: 26px;
                justify-content: center;
                margin: 0 5px;
                transition: opacity 0.3s;
                width: 26px;

                .material-icons {
                    color: #fff;
                    font-size: 15px;
                }
            }
        }
    }

    .wp-list-searching-input {
        margin: 5px 5px !important;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        text-align: center;
    }

    .inputs {
        border: 1px solid #e5e5e5;
        position: relative;
        border-radius: 6px;
        -webkit-box-shadow: 0 0 1px #00000080;
        box-shadow: 0 0 1px #00000080;
    }
}
</style>
<style lang="scss">
.import-contact-modal {
    .ant-modal {
        width: 91vw !important;
        top: 30px !important;
        left: 30px !important;
    }

    .ant-modal-content {
        height: 95vh !important;
    }

    .ant-modal-body,
    .custom-modal-content {
        height: 100%;
    }
}
</style>
